var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("circle", { cx: "20", cy: "20", r: "18", fill: "#FFF" }),
      React.createElement("path", { fill: "#018489", fillOpacity: ".2", d: "M30.36 5.894C34.69 9.08 37.5 14.212 37.5 20c0 9.665-7.835 17.5-17.5 17.5-5.788 0-10.92-2.81-14.106-7.14a17.428 17.428 0 0 0 10.356 3.39c9.665 0 17.5-7.835 17.5-17.5 0-3.844-1.24-7.399-3.34-10.286z" }),
      React.createElement("path", { fill: "#303030", d: "M20 1.5c10.217 0 18.5 8.283 18.5 18.5S30.217 38.5 20 38.5 1.5 30.217 1.5 20 9.783 1.5 20 1.5zm0 2C10.887 3.5 3.5 10.887 3.5 20S10.887 36.5 20 36.5 36.5 29.113 36.5 20 29.113 3.5 20 3.5zm0 18c2.81 0 5.178 1.184 7.03 3.5a1 1 0 1 1-1.56 1.25C23.988 24.4 22.19 23.5 20 23.5s-3.989.9-5.47 2.75A1 1 0 1 1 12.97 25c1.852-2.316 4.22-3.5 7.03-3.5zm-5.625-7.75a1.875 1.875 0 1 1 0 3.75 1.875 1.875 0 0 1 0-3.75zm11.25 0a1.875 1.875 0 1 1 0 3.75 1.875 1.875 0 0 1 0-3.75z" })
    )
  );
});